var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.333,
    height: 7.333,
    viewBox: "0 0 1.94 1.94",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 7.331 -14.075)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -24.041,
    cy: 56.865,
    r: 3.52,
    fill: "#3a3a3a",
    stroke: "#3a3a3a",
    strokeWidth: 0.293
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -24.041,
    cy: 56.865,
    r: 1.467,
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.69bec0e71e767cbf37b20627edcd06e0.svg";
export { ForwardRef as ReactComponent };